// eslint-disable-next-line @typescript-eslint/no-empty-function -- Legitimate
export function noop() {}
export function noopNull() {
  return null;
}